import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/Catalog/Search.jsx");
